import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { MdLogout, MdMenu, MdNotifications, MdOutlineMessage, MdOutlineNotifications } from "react-icons/md";
import { IoChevronBack, IoNotificationsOutline, IoRefreshCircleOutline } from "react-icons/io5";
import { TbMessageDots, TbNotification } from "react-icons/tb";
import { callApi, getTopBarTitle, setCookie } from "../Helpers";
import { AiOutlineNotification, AiOutlineUser, AiTwotoneNotification } from 'react-icons/ai';
import { BiSolidNotification } from "react-icons/bi";
import logo_worded_only from '../assets/logo_worded_only.png';

export default function TopBar(props) {

  const appContext = useContext(AppContext);
  const [title, setTitle] = useState("");


  useEffect(() => {
    let _title = getTopBarTitle(appContext); 

    if(_title) {
      setTitle(_title);
    }
  }, [ appContext.navItem, appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem ])

  return (
    <div
      className="TopBar"
    >

      <div
        className="container d-flex justify-content-between"
        style={{
          height: "100%",
        }}
      >


        <div
          className="mIcon text-start mOneLineText"
        >
          <img
            src={logo_worded_only}
            style={{
              height: "80%",
              width: "auto",
              borderRadius: "10px"
            }}
          />
          <span
            className="font-bold"
            style={{
              fontSize: "12px",
              paddingLeft: "5px"
            }}
          >
            By ATAN Global
          </span>
        </div>



        <div
          className="mIcon text-end align-self-center"
          onClick={() => {
            appContext.navTo({
              item: 'notifications',
            })
          }}
        >

          <IoNotificationsOutline
            className="mSymbol"
          />

          {
            (JSON.parse(appContext.currentUserData.newNotifications).length > 0) ?
            <span className="mBadge">{JSON.parse(appContext.currentUserData.newNotifications).length}</span>
            :""
          }
        </div>

      </div>
    </div>
  )
}